import React from 'react';

export function BatteryIcon({ percentage }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      aria-hidden="true"
      width="1em"
      height="1em"
    >
      <path
        d="M32,64h168c8.8,0,16,7.2,16,16v96c0,8.8-7.2,16-16,16H32c-8.8,0-16-7.2-16-16V80C16,71.2,23.2,64,32,64z"
        fill="none"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* middle shape representing battery charge factor */}
      <rect
        x="46"
        y="91"
        width={140 * (percentage / 100)}
        height="74"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="220"
        y="96"
        width={16}
        height={64}
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
